import useDecodedUser from "../services/hooks/useDecodedUser";
import { CapitalizeWords } from "../utils/Formatting";
import { Box, Grid, Typography } from "@mui/material";

export default function IPDCWelcomeMessage({ messageTitle }) {
  const decodedUser = useDecodedUser();
  //console.log(decodedUser);
  return (
    <>
      <Grid item sm={12} md={12} px={1}>
        <Box id="my-container">
          <Typography
            id="my-text"
            sx={{
              fontSize: messageTitle?.length > 20 ? "20px" : "22px",
              fontWeight: 600,
              color: "black",
             
            }}
          >
            {messageTitle + " "}
            {/* {decodedUser?.role || ""}  */}
            {" Dashboard"}
          </Typography>
        </Box>
        <Typography sx={{ fontSize: 12, fontWeight: 500, color: "#737373" }}>
          Welcome back,{" "}
          {decodedUser && CapitalizeWords((decodedUser?.title || "") + " " + (decodedUser?.full_name || ""))}
        </Typography>
      </Grid>
    </>
  );
}
